<div class="auth-flex-columns">
    <div class="auth-inner-wrapper min-height">
        <div class="form-block">
            <div class="heading no-margin-bottom">
                <h1 class="page-title">Error</h1>
                <img class="description-img" src="./../../../../assets/images/auth/error.svg" alt="authentication-error">
                <h2 class="subtext">Something went wrong</h2>
                <p class="auth-page-description error">Sorry, there was a server error trying to active your new account. Please try again now or later.</p>
                    <div class="extra-links">
                        <p class="line">
                            <span><a (click)="openLoginDialog()">Try again</a></span>
                        </p>
                    </div>
            </div>
        </div>
    </div>

    <div class="banner-container">
        <app-current-banner [minWidth]="380" [authDialogStyles]="true"></app-current-banner>
    </div>

</div>
   